let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cNNvu")).then(() => parcelRequire('57sgG'));